import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import "./admin.css";
import { API_END_POINT } from '../../config';



const MaintenanceForm = ({ mode, selectedRowData, modules, onClose, email }) => {
    const [formData, setFormData] = useState({
        maintenanceTitle: '',
        moduleId: null,
        startDate: null,
        endDate: null,
    });



    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const toast = React.useRef(null);
    const [calendarTempStart, setcalendarTempStart] = useState(null);
    const [calendarTempEnd, setcalendarTempEnd] = useState(null);
    const [showStartCal, setShowStartCal] = useState(false);
    const [showEndCal, setShowEndCal] = useState(false);




    useEffect(() => {
        if (mode === 'edit' && selectedRowData) {

            setFormData({
                maintenanceTitle: selectedRowData.maintenanceTitle || '',
                moduleId: selectedRowData.moduleId || null,
                startDate: selectedRowData.startDate ? new Date(selectedRowData.startDate) : null,
                endDate: selectedRowData.endDate ? new Date(selectedRowData.endDate) : null,
            });
        } else {
            setFormData({
                maintenanceTitle: '',
                moduleId: null,
                startDate: null,
                endDate: null,
            });
        }
    }, [mode, selectedRowData]);



    const validate = () => {
        const errs = {};
        const now = new Date();
        if (!formData.maintenanceTitle.trim()) errs.maintenanceTitle = 'Title is required';
        if (!formData.moduleId) errs.moduleId = 'Module is required';
        if (!formData.startDate) {
            errs.startDate = 'Start date is required';
        } else if (formData.startDate < now) {
            errs.startDate = 'Start date/time cannot be in the past';

        }
        if (!formData.endDate) {
            errs.endDate = 'End date is required';
        } else if (formData.endDate < formData.startDate) {
            errs.startDate = 'End date must be after start date';

        }
        return errs;
    };



    const handleSubmit = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }



        const payload = {
            maintenanceTitle: formData.maintenanceTitle,
            moduleId: formData.moduleId,
            startDate: formData.startDate.getTime(),
            endDate: formData.endDate.getTime(),
            active: 1
            // maintenanceStatus: mode === 'edit' ? selectedRowData?.maintenanceStatus : 1,
        };

        if (mode === 'edit' && selectedRowData?.maintenanceId) {
            payload["maintenanceId"] = selectedRowData?.maintenanceId;
        }


        try {
            setIsSubmitting(true);
            if (mode === 'edit') {
                await axios.put(`${API_END_POINT.BASE_URL.CI_SERVICE}/api/maintenance/${selectedRowData.maintenanceId}?email=${email}`, payload);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Maintenance updated successfully' });
            } else {
                await axios.post(`${API_END_POINT.BASE_URL.CI_SERVICE}/api/maintenance?email=${email}`, payload);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Maintenance created successfully' });
            }
            setTimeout(() => onClose(true), 1200); // Delay so user sees the toast
        } catch (err) {
            setIsSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save maintenance' });
            setTimeout(() => onClose(true), 1200); // Delay so user sees the toast

        } finally {
            setIsSubmitting(false);
        }
    };



    const onInputChange = (e, name) => {
        setFormData({ ...formData, [name]: e.target.value });
        setErrors({ ...errors, [name]: null });
    };



    return (
        <>
            <Toast ref={toast} />
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="maintenanceTitle">Maintenance Title</label>
                    <InputText
                        id="maintenanceTitle"
                        value={formData.maintenanceTitle}
                        onChange={(e) => onInputChange(e, 'maintenanceTitle')}
                        className={errors.maintenanceTitle ? 'p-invalid' : ''}
                    />
                    {errors.maintenanceTitle && <small className="p-error">{errors.maintenanceTitle}</small>}
                </div>



                <div className="field">
                    <label htmlFor="moduleId">Module</label>
                    <Dropdown
                        id="moduleId"
                        disabled={mode === 'edit'}
                        value={formData.moduleId}
                        options={modules}
                        optionLabel="moduleName"
                        optionValue="moduleId"
                        placeholder="Select a module"
                        onChange={(e) => onInputChange(e, 'moduleId')}
                        className={errors.moduleId ? 'p-invalid' : ''}
                    />
                    {errors.moduleId && <small className="p-error">{errors.moduleId}</small>}
                </div>



                <div className="field">
                    <label htmlFor="startDate">Start Date & Time</label>
                    <Calendar
                        id="startDate"
                        value={formData.startDate}
                        onChange={(e) => onInputChange(e, 'startDate')}
                        showTime
                        showSeconds
                        showIcon
                        minDate={new Date()}
                        className={`small-calendar ${errors.startDate ? 'p-invalid' : ''}`}

                    />

                    {errors.startDate && <small className="p-error">{errors.startDate}</small>}
                </div>



                <div className="field">
                    <label htmlFor="endDate">End Date & Time</label>
                    <Calendar
                        id="endDate"
                        value={formData.endDate}
                        onChange={(e) => onInputChange(e, 'endDate')}
                        showTime
                        showSeconds
                        showIcon
                        showButtonBar
                        minDate={formData.startDate || new Date()}
                        className={errors.endDate ? 'p-invalid' : ''}
                    />
                    {errors.endDate && <small className="p-error">{errors.endDate}</small>}
                </div>



                <div className="mt-3 d-flex justify-content-end gap-2">                    
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="p-button-text"
                        onClick={() => onClose(false)}
                        disabled={isSubmitting}
                    />
                    <Button
                        label={mode === 'edit' ? 'Update' : 'Create'}
                        icon="pi pi-check"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    />
                </div>
            </div>
        </>
    );
};



export default MaintenanceForm;